/* global mixpanel */

export function registrationStart () {
  mixpanel.track('Registration Start')
}

export function registrationBusinessInfo ({email}) {
  mixpanel.track('Registration Create Email', {email})
}

export function registrationCompleted ({user, business}) {
  mixpanel.track('Registration Create Business', {
    'Email': user.email,
    'First Name': user.first_name,
    'Last Name': user.last_name,
    'Phone': user.phone,
    'Business Name': business.name,
    'Business Type ID': business.business_type_id,
    // 'Business Type Name': '',
    'Business Category ID': business.business_category_id,
    // 'Business Category Name':'',
    'Business Address': business.address,
    'Business City': business.city,
    'Business State': business.state,
    'Business Zip': business.postal_code
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/register/index.js